import styled from "@emotion/styled"
import Image from "next/image"
import colors from "theme/colors"
import { NewText, useIsDesktop } from "ui"
import { extractProperty } from "utils"
import { httpsImage } from "utils/utils"

const StyledContainer = styled.div<{
  backgroundDesktop: string
  backgroundMobile: string
}>`
  position: relative;
  height: auto;
  width: 100%;
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;
  aspect-ratio: 348 / 650;
  ${(props) => props.theme.breakpoints.up("md")} {
    width:auto;
    aspect-ratio: initial;
  }
  ${(props) => props.theme.breakpoints.up("lg")} {
    width:auto;
    aspect-ratio: initial;
  }
`
const StyledTextContainer = styled.div`
  position: absolute;
  top: 14px;
  right: 0px;
  width: 50%;
  p {
    margin: 0px;
    margin-top: 12px;
  }
  ${(props) => props.theme.breakpoints.down("md")} {
    left: 25px;
  }
  ${(props) => props.theme.breakpoints.down("md")} {
    aspect-ratio: initial;
    width: 300px;
    left: 25px;
  }
  // ${(props) => props.theme.breakpoints.up("md")} {
  //   top: 50%;
  //   transform: translateY(-50%);
  //   right: 219px;
  //   width: 468px;
  // }
  // ${(props) => props.theme.breakpoints.up("lg")} {
  //   //  width: 700px;
  //   right: 119px;
  // }
  // ${(props) => props.theme.breakpoints.up("xl")} {
  //   top: 50%;
  //   transform: translateY(-50%);
  //   right: 219px;
  // }
`

const StyledDownloadsContainer = styled.div`
  display: flex;
  flex-direction: column;
  p {
    margin-top: 16px;
    ${(props) => props.theme.breakpoints.up("md")} {
      margin-top: 44px;
    }
  }
`

const StyledQRContainer = styled.div`
  margin-top: 4px;
  width: 68.85px;
  height: 68.85px;
  border-radius: 10px;
  overflow: hidden;
  position: relative;

  ${(props) => props.theme.breakpoints.up("md")} {
    width: 100px;
    margin-top: 16px;
    height: 100px;
  }
  ${(props) => props.theme.breakpoints.up("xl")} {
    width: 128px;
    margin-top: 28px;
    height: 128px;
  }
`

const StyledAppStoreContainer = styled.div`
  display: flex;
  gap: 13.99px;
  margin-top: 17.21px;
  ${(props) => props.theme.breakpoints.up("md")} {
    margin-top: 25px;
    gap: 20px;
  }

  ${(props) => props.theme.breakpoints.up("xl")} {
    margin-top: 32px;
    gap: 26px;
  }
`

const StyledDownload = styled.a`
  position: relative;
  height: 43.03px;
  width: 144.45785714px;
  ${(props) => props.theme.breakpoints.up("md")} {
    height: 50px;
    width: 190px;
  }

  ${(props) => props.theme.breakpoints.up("xl")} {
    height: 80px;
    width: 268.57142857px;
  }
`
const StyledBeforeQR = styled(NewText)`
  p {
    margin: 0;
  }
  padding-top: 16px;
`

const Padding = styled.div`
  padding-left: 28px;
  ${(props) => props.theme.breakpoints.up("md")} {
    padding-left: 100px;
  }
  ${(props) => props.theme.breakpoints.up("lg")} {
    padding-left: 150px;
  }
`
const AspectRatioBox = styled.div`
  position: relative;
  width: 100%;
  aspect-ratio: 1770 / 820;
  img {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }
  ${(props) => props.theme.breakpoints.down("lg")} {
     aspect-ratio: 1180 / 547;
  }
  ${(props) => props.theme.breakpoints.down("md")} {
    height: 100%;
  }
`;
type Props = {
  data: any
}
function MainBanner({ data }: Props) {
  const title = extractProperty(data, "title")
  const subTitle = extractProperty(data, "subTitle")
  const text = extractProperty(data, "text")
  const backgroundDesktop = extractProperty(data, "backgroundImageDescktop")
  const backgroundMobile = extractProperty(data, "backgroundImageMobile")
  const isDesktop = useIsDesktop()

  return (
    <Padding>
      <StyledContainer
        backgroundDesktop={backgroundDesktop}
        backgroundMobile={backgroundMobile}
      >

        <AspectRatioBox>
          <Image
            fill
            src={httpsImage(isDesktop ? backgroundDesktop : backgroundMobile)}
            alt=""
            objectPosition={"top"}
            objectFit={isDesktop ? "fill" : "cover"}
            priority
            quality={85}
          />
        </AspectRatioBox>
        <StyledTextContainer>
          <NewText
            component={"h1"}
            largeDesktopFontSize={80}
            desktopFontWeight={500}
            largeDesktopLineHeight={"102.4px"}
            desktopFontSize={54}
            desktopLineHeight="69.12px"
            color={"rgba(226, 0, 47, 1)"}
            mobileFontSize={28}
            mobileLineHeight={"35.84px"}
          >
            {title}
          </NewText>
          <NewText
            component={"div"}
            largeDesktopFontSize={48}
            desktopFontWeight={400}
            largeDesktopLineHeight={"57.6px"}
            desktopFontSize={32}
            desktopLineHeight="38.4px"
            color={colors.black}
            mobileFontSize={18}
            mobileLineHeight={"24px"}
            dangerouslySetInnerHTML={{
              __html: subTitle.replaceAll("<p> </p>", ""),
            }}
          />
          <StyledDownloadsContainer>
            <StyledBeforeQR
              component={"div"}
              largeDesktopFontSize={36}
              desktopFontWeight={400}
              largeDesktopLineHeight={"50.4px"}
              desktopFontSize={27}
              desktopLineHeight="37.8px"
              color={colors.black}
              mobileFontSize={18}
              mobileFontWeight={500}
              mobileLineHeight={"25.2px"}
              dangerouslySetInnerHTML={{ __html: text }}
            />
            <StyledQRContainer>
              <Image
                src="/new-app-qr.png"
                fill
                alt="סריקת qr"
                loading="eager"
                quality={95}
              />
            </StyledQRContainer>
            <StyledAppStoreContainer>
              <StyledDownload href="https://yellow.onelink.me/HpLh?af_js_web=true&af_ss_ver=2&pid=Paz_website&c=Yellowapp_organic">
                <Image
                  style={{ objectFit: "contain" }}
                  src="/images/google-play-badge.png"
                  fill
                  alt="google play"
                  loading="eager"
                />
              </StyledDownload>
              <StyledDownload href="https://yellow.onelink.me/HpLh?af_js_web=true&af_ss_ver=2&pid=Paz_website&c=Yellowapp_organic">
                <Image
                  style={{ objectFit: "contain" }}
                  src="/images/play-store-badge.png"
                  fill
                  alt="app store"
                  loading="eager"
                />
              </StyledDownload>
            </StyledAppStoreContainer>
          </StyledDownloadsContainer>
        </StyledTextContainer>
      </StyledContainer>
    </Padding>
  )
}

export default MainBanner
